<div class="modal-header">
    <h4 class="modal-title">Artes Fuente: <strong>{{ data.strategy.name }}</strong></h4>
    <button type="button" class="btn-close" (click)="close()" aria-label="Cerrar"></button>
</div>
<mat-dialog-content>
    <div class="modal-body">
        <h6 class="pb-4">
            <span class="align-middle">Sube un nuevo archivo de artes fuente:</span>
        </h6>
        <form [formGroup]="form">
            <ngx-file-drag-drop class="ngx-file_f" emptyPlaceholder="Arrastre o seleccione archivo"  [formControl]="fileControl" (valueChanged)="onValueChange($event)">
            </ngx-file-drag-drop>
        </form>
    </div>
</mat-dialog-content>
<div class="modal-footer pt-4">
    <button mat-button (click)="close()">Cancelar<mat-icon>close</mat-icon></button>
    <button mat-flat-button class="btn bg-success text-white" [disabled]="uploading" type="button" (click)="saveDistributionArt()">Registrar cambios <mat-icon>save</mat-icon></button>
</div>

<ng-template #uploadProgress>
    <h2 mat-dialog-title class="text-center">{{ confirming ? 'Confirmando archivo...' : 'Subiendo archivo...' }}</h2>
    <mat-dialog-content class="text-center" role="status" aria-live="polite">
        <div class="upload-progress">
            <mat-progress-spinner [diameter]="100" [mode]="usePresignedUpload && !confirming ? 'determinate' : 'indeterminate'" [value]="progress"></mat-progress-spinner>
            <span *ngIf="usePresignedUpload" class="upload-percentage">{{ progress }}%</span>
        </div>
        <p *ngIf="delayed">Esto podría tomar un poco más de tiempo.</p>
        <p>Espera a que termine la carga. No cierres ni recargues la página.</p>
    </mat-dialog-content>
</ng-template>
